function values(argu) {

    var size = $('select[name="size"]').find(':selected').val();
    var color = $('select[name="color"]').find(':selected').val();
    if(argu.parent('.product-form__item').hasClass('color-option')) {
       color =  argu.find(':selected').val();
       size = argu.parents('.color-option').siblings('.size-option').find('select[name="size"] option:selected').val(); 
    } else {
       size =  argu.find(':selected').val();
      color = argu.parents('.size-option').siblings('.color-option').find('select[name="color"] option:selected').val(); 
    }  


    if(color && size){
      $('.variant-loop__list select').find('option').each(function(){
        var comp = $(this).text();
        $(this).attr('selected', false);
        if(comp.includes(size) && comp.includes(color)){         
          $(this).attr('selected', true);
        }
      })
    }else if(size){
      $('.variant-loop__list select').find('option').each(function(){
        var comp = $(this).text();
        $(this).attr('selected', false);
        if(comp.includes(size)){
          $(this).attr('selected', true);
        }
      })

    }else if(color){
      $('.variant-loop__list select').find('option').each(function(){
        var comp = $(this).text();
        $(this).attr('selected', false);
        if(comp.includes(color)){
          $(this).attr('selected', true);
        }
      })

    }

  }
  values($(this));
  $('select[name="size"], select[name="color"]').change( function(e) {
    values($(this));

  });

 $('.collection-slideToggle').on('click',function(e){
    e.preventDefault();
    	$(this).siblings('.option_list').slideToggle();
  })